module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/3_4.bd4ce98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/3_4.jpg
// module id = tpv9
// module chunks = 0